export default __webpack_public_path__ + "static/media/ufs2(1).0d80b7ec.jpg";